var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollar = function SvgDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.875A10.125 10.125 0 1 0 22.125 12 10.137 10.137 0 0 0 12 1.875m0 18A7.875 7.875 0 1 1 19.875 12 7.883 7.883 0 0 1 12 19.875m4.125-6a3 3 0 0 1-3 3v.375a1.125 1.125 0 1 1-2.25 0v-.375H9.75a1.125 1.125 0 1 1 0-2.25h3.375a.75.75 0 1 0 0-1.5h-2.25a3 3 0 0 1 0-6V6.75a1.125 1.125 0 1 1 2.25 0v.375h1.125a1.125 1.125 0 0 1 0 2.25h-3.375a.75.75 0 1 0 0 1.5h2.25a3 3 0 0 1 3 3"
  })));
};
export default SvgDollar;